/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'tools.ozone.communication.defs'

export { $nsid }

type TemplateView = {
  $type?: 'tools.ozone.communication.defs#templateView'
  id: string

  /**
   * Name of the template.
   */
  name: string

  /**
   * Content of the template, can contain markdown and variable placeholders.
   */
  subject?: string

  /**
   * Subject of the message, used in emails.
   */
  contentMarkdown: string
  disabled: boolean

  /**
   * Message language.
   */
  lang?: l.LanguageString

  /**
   * DID of the user who last updated the template.
   */
  lastUpdatedBy: l.DidString
  createdAt: l.DatetimeString
  updatedAt: l.DatetimeString
}

export type { TemplateView }

const templateView = l.typedObject<TemplateView>(
  $nsid,
  'templateView',
  l.object({
    id: l.string(),
    name: l.string(),
    subject: l.optional(l.string()),
    contentMarkdown: l.string(),
    disabled: l.boolean(),
    lang: l.optional(l.string({ format: 'language' })),
    lastUpdatedBy: l.string({ format: 'did' }),
    createdAt: l.string({ format: 'datetime' }),
    updatedAt: l.string({ format: 'datetime' }),
  }),
)

export { templateView }
